import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a089473"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sc-cropper"
};
const _hoisted_2 = {
  class: "sc-cropper__img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "sc-cropper__preview"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "图像预览", -1));
const _hoisted_6 = {
  class: "sc-cropper__preview__img",
  ref: "preview"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $props.src,
    ref: "img"
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, null, 512)])]);
}